import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
import {RepositoryFactory} from '../api/RepositoryFactory'
const SettingsRepoGet = RepositoryFactory.get('settings')
Vue.use(Vuex)
const vuexLocalStorage = new VuexPersist({
 key: 'vuex', 
 storage: window.localStorage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
	plugins: [vuexLocalStorage.plugin],
	state:{
			bid: null,
			storeId: null,
			subscriptionType: null,
			sameDayOffset: -2,
			loggedIn: false,
			baseUrl: null,
			settings: {
				availableLockers: 0,
				availableSlots: 0,					
				deliverySlots: 0,
				clickandcollectEnabled: null,
				lockerEnabled: null,
				deliveryEnabled: null,
				startSelectedDesk: null,
				startSelectedLocker: null,
				startSelectedDelivery: null,
				endSelectedDesk : null,
				endSelectedLocker : null,
				endSelectedDelivery : null,
				reserverdForMins :  60,
				packagingSlipPromo: null,
				packagingSlipText: null,
				resendSMS : false,
				creditsPerSMS : 2, // this is the number of sms credits each message costs
				storeShortName: "",
				customSMSText: null,
				wwwBitly : 'https://bit.ly/2XvoCpl',
				wwwAddress: 'https://www.creativeconnections.co.uk/',
				qrCodeURL: 'http://www.scanandget.co.uk/sfd/index.php?id=34',
				sameDayOffset: -2,
				secToken: null,
				logo: 'demo-clothing-store-logo.png',
				identifyType : "",
				customCollectInstructions : "",
				imHereInstructionsURL: "",
				imHere: null,
				notificationEmail : "",
				notificationTel : ""					
			}		
	},
	actions:{
		async getSettings({commit}){
			const {data}  =	await SettingsRepoGet.getAllStoreSettings()	
			commit('getStoreSettings', data)
		},
		async logIn({commit}, payload){
			console.log("The following logs are from the vuex index login action")
			console.log(payload[0].sectoken)
			console.log(payload[1].storeId)
			console.log(payload[3].subscriptionType)
			const {data}  =	await SettingsRepoGet.getAllStoreSettings(payload[1].storeId)	
		
			commit('setStore', payload)
			commit('getStoreSettings', data)
	
			let setting = data.filter((item)=> item.name == 'secToken');
			if(payload[0].sectoken == setting[0].value)
			{
				commit('logIn')
			}
		}		
	},
	mutations:{
		getStoreSettings(state, payload){
			state.storeId = payload[0].store_id
			state.bid = payload[0].store_id
			console.log(payload)

			let availableLockers = payload.filter((item)=> item.name == 'availableLockers')
			let availableSlots = payload.filter((item)=> item.name == 'availableSlots')
			let deliverySlots = payload.filter((item)=> item.name == 'deliverySlots')	
			
			let startSelectedDesk = payload.filter((item)=> item.name == 'startSelectedDesk')
			let endSelectedDesk = payload.filter((item)=> item.name == 'endSelectedDesk')
			let startSelectedLocker = payload.filter((item)=> item.name == 'startSelectedLocker')
			let endSelectedLocker = payload.filter((item)=> item.name == 'endSelectedLocker')
			let startSelectedDelivery = payload.filter((item)=> item.name == 'startSelectedDelivery')
			let endSelectedDelivery = payload.filter((item)=> item.name == 'endSelectedDelivery')
			
			let clickandcollectEnabled = payload.filter((item)=> item.name == 'clickandcollectEnabled')
			let lockerEnabled = payload.filter((item)=> item.name == 'lockerEnabled')
			let deliveryEnabled = payload.filter((item)=> item.name == 'deliveryEnabled')	
			
			let reserverdForMins = payload.filter((item)=> item.name == 'reserverdForMins')
			
			let imHere = payload.filter((item)=> item.name == 'imHere')
			let imHereInstructionsURL = payload.filter((item)=> item.name == 'imHereInstructionsURL')
			let customCollectInstructions = payload.filter((item)=> item.name == 'customCollectInstructions')

			let packagingSlipPromo = payload.filter((item)=> item.name == 'packagingSlipPromo')
			let qrCodeURL = payload.filter((item)=> item.name == 'qrCodeURL')
			let packagingSlipText = payload.filter((item)=> item.name == 'packagingSlipText')
			
			let resendSMS = payload.filter((item)=> item.name == 'resendSMS')
			let customSMSText = payload.filter((item)=> item.name == 'customSMSText')
			let wwwBitly = payload.filter((item)=> item.name == 'wwwBitly')
			let storeShortName = payload.filter((item)=> item.name == 'storeShortName')
			let wwwAddress = payload.filter((item)=> item.name == 'wwwAddress')

			let sameDayOffset = payload.filter((item)=> item.name == 'sameDayOffset')
			let secToken = payload.filter((item)=> item.name == 'secToken')
			
			let storeLogo  = payload.filter((item)=> item.name == 'storeLogo')
			let identifyType = payload.filter((item)=> item.name == 'identifyType')
			let notificationEmail = payload.filter((item)=> item.name == 'notificationEmail')
			let notificationTel = payload.filter((item)=> item.name == 'notificationTel')
			
			state.settings.availableLockers = availableLockers[0].value
			state.settings.availableSlots = availableSlots[0].value
			state.settings.deliverySlots = deliverySlots[0].value
			
			state.settings.startSelectedDesk = startSelectedDesk[0].value
			state.settings.endSelectedDesk = endSelectedDesk[0].value
			state.settings.startSelectedLocker = startSelectedLocker[0].value
			state.settings.endSelectedLocker = endSelectedLocker[0].value
			state.settings.startSelectedDelivery = startSelectedDelivery[0].value
			state.settings.endSelectedDelivery = endSelectedDelivery[0].value
			
			state.settings.clickandcollectEnabled = clickandcollectEnabled[0].value
			state.settings.lockerEnabled = lockerEnabled[0].value
			state.settings.deliveryEnabled = deliveryEnabled[0].value	
						
			state.settings.reserverdForMins = reserverdForMins[0].value
			state.settings.packagingSlipPromo = packagingSlipPromo[0].value
			state.settings.packagingSlipText = packagingSlipText[0].value
			
			state.settings.imHere = imHere[0].value
			state.settings.customCollectInstructions = customCollectInstructions[0].value
			state.settings.imHereInstructionsURL = imHereInstructionsURL[0].value
			
			state.settings.resendSMS = resendSMS[0].value
			state.settings.customSMSText = customSMSText[0].value
			state.settings.wwwBitly = wwwBitly[0].value
			state.settings.storeShortName = storeShortName[0].value
			state.settings.wwwAddress = wwwAddress[0].value
			
			state.settings.qrCodeURL = qrCodeURL[0].value
			state.settings.sameDayOffset = sameDayOffset[0].value * -1
			state.sameDayOffset = sameDayOffset[0].value * -1 // this should be removed once found in code and replaced with the one above (see below also)
			state.settings.secToken = secToken[0].value
			
			state.settings.storeLogo = storeLogo[0].value
			state.settings.identifyType = identifyType[0].value
			state.settings.notificationEmail = notificationEmail[0].value
			state.settings.notificationTel = notificationTel[0].value
			
		},
		setStore(state, payload)
		{
			console.log("The following logs are from the vuex index set store mutation action")			
			console.log(payload[0].sectoken)
			console.log(payload[1].storeId)
			console.log(payload[2].loggedIn)


			state.storeId = payload[1].storeId
			state.bid = payload[1].storeId	
			state.subscriptionType = payload[3].subscriptionType;
		
				let baseUrl = ''
				let apiUrl = ''
				switch(window.location.host)
				{		
					case 'clickandcollect.scanandget-development.co.uk':
					baseUrl = 'https://www.scanandget-development.co.uk/';
					apiUrl = "https://api.scanandget-development.co.uk";
		
					break;
					case 'clickandcollect.scanandget-staging.co.uk':
					baseUrl = 'https://www.scanandget-staging.co.uk/';
					apiUrl = "https://api.scanandget-staging.co.uk";
		
					break;
					case 'clickandcollect.scanandget.co.uk':
					baseUrl = 'https://www.scanandget.co.uk/';
					apiUrl = "https://api.scanandget.co.uk";
					break;
					default:
					baseUrl = 'http://localhost/scanandget/public_html/';
					apiUrl = "http://localhost/clickcollect/public_html";
		
					break;
				}			
				state.baseUrl= baseUrl
				state.apiUrl = apiUrl
		},
		logOut(state)
		{				
			state.loggedIn = false
		},
		logIn(state)
		{				
			state.loggedIn = true
		},
		updateStoreSettings(state, payload){
			var settingType = payload.filter((item)=> item.key == 'settingType').map((obj)=>   obj.value )
			let clickandcollectEnabled = ""
			let lockerEnabled = ""	
			let deliveryEnabled = ""

			let availableLockers = ""
			let availableSlots = ""
			let deliverySlots = ""

			let sameDayOffset = ""

						
			let imHere = ""
			let imHereInstructionsURL = ""
			let customCollectInstructions = ""
			
			let packagingSlipPromo = ""
			let qrCodeURL = ""
			let packagingSlipText = ""
			
			let resendSMS = ""
			let customSMSText = ""
			let wwwBitly = ""
			
			let coreStartHour = ""
			let coreEndHour = ""
			
			let fulfilmentTypes  =  null;
						
			switch(settingType[0])
			{
				case 'orderTypesEnabled':
				clickandcollectEnabled = payload.filter((item)=> item.key == 'fulfilmentOptions').map((obj)=> { let item = obj.value.filter((item)=> item == 'clickandcollectEnabled'); return  (item.length >= 1)? 1 : 0})			
				lockerEnabled = payload.filter((item)=> item.key == 'fulfilmentOptions').map((obj)=> { let item = obj.value.filter((item)=> item == 'lockerEnabled'); return  (item.length >= 1)? 1 : 0})			
				deliveryEnabled = payload.filter((item)=> item.key == 'fulfilmentOptions').map((obj)=> { let item = obj.value.filter((item)=> item == 'deliveryEnabled'); return  (item.length >= 1)? 1 : 0})

				availableLockers = payload.filter((item)=> item.key == 'availableLockers').map(function(obj) { return obj.value;})
				availableSlots = payload.filter((item)=> item.key == 'availableSlots').map(function(obj) { return obj.value;})
				deliverySlots = payload.filter((item)=> item.key == 'deliverySlots').map(function(obj) { return obj.value;})

				sameDayOffset =  payload.filter((item)=> item.key == 'sameDayOffset').map(function(obj) { return obj.value;})
				
				state.settings.clickandcollectEnabled = clickandcollectEnabled[0]
				state.settings.lockerEnabled = lockerEnabled[0]
				state.settings.deliveryEnabled = deliveryEnabled[0]
				state.settings.sameDayOffset = sameDayOffset[0]  * -1
				state.sameDayOffset = sameDayOffset[0]  * -1 
				state.settings.availableLockers = availableLockers[0]
				state.settings.availableSlots = availableSlots[0]
				state.settings.deliverySlots = deliverySlots[0]
				break;
				case 'order&collect':				
				imHere = payload.filter((item)=> item.key == 'imHere').map(function(obj) { return obj.value;})
				imHereInstructionsURL = payload.filter((item)=> item.key == 'imHereInstructionsURL').map(function(obj) { return obj.value;})
				customCollectInstructions = payload.filter((item)=> item.key == 'customCollectInstructions').map(function(obj) { return obj.value;})
				
				state.settings.imHere = imHere[0]
				state.settings.imHereInstructionsURL = imHereInstructionsURL[0]
				state.settings.customCollectInstructions = customCollectInstructions[0]
				break;
				case 'PackagingSlip':				
				packagingSlipPromo = payload.filter((item)=> item.key == 'packagingSlipPromo').map(function(obj) { return obj.value;})
				qrCodeURL = payload.filter((item)=> item.key == 'qrCodeURL').map(function(obj) { return obj.value;})
				packagingSlipText = payload.filter((item)=> item.key == 'packagingSlipText').map(function(obj) { return obj.value;})
				
				state.settings.packagingSlipPromo = packagingSlipPromo[0]
				state.settings.qrCodeURL = qrCodeURL[0]
				state.settings.packagingSlipText = packagingSlipText[0]
				break;	
				case 'SMS':
				resendSMS = payload.filter((item)=> item.key == 'resendSMS').map(function(obj) { return obj.value;})
				customSMSText = payload.filter((item)=> item.key == 'customSMSText').map(function(obj) { return obj.value;})
				wwwBitly = payload.filter((item)=> item.key == 'wwwBitly').map(function(obj) { return obj.value;})

				state.settings.resendSMS = resendSMS[0]
				state.settings.customSMSText = customSMSText[0]
				state.settings.wwwBitly = wwwBitly[0]
				break;	
				case 'coreHours':
				fulfilmentTypes = payload.filter((item)=> item.key == 'fulfilmentTypes').map(function(obj) { return obj.value;})
				coreStartHour = payload.filter((item)=> item.key == 'coreStartHour').map(function(obj) { return obj.value;})
				coreEndHour = payload.filter((item)=> item.key == 'coreEndHour').map(function(obj) { return obj.value;})
				console.log(fulfilmentTypes[0])
				if(fulfilmentTypes[0].includes('clickandcollect'))
				{
					console.log('startSelectedDesk = ' + coreStartHour)
					state.settings.startSelectedDesk = coreStartHour[0]
					state.settings.endSelectedDesk = coreEndHour[0]					
				}
								
				if(fulfilmentTypes[0].includes('locker'))
				{
					console.log('startSelectedLocker = ' + coreStartHour)
					state.settings.startSelectedLocker = coreStartHour[0]
					state.settings.endSelectedLocker = coreEndHour[0]					
				}
								
				if(fulfilmentTypes[0].includes('delivery'))
				{
					console.log('startSelectedDelivery = ' + coreStartHour)
					state.settings.startSelectedDelivery = coreStartHour[0]
					state.settings.endSelectedDelivery = coreEndHour[0]	
					
				}
				break;
			}			

		}
	}
})

